import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen } from 'lucide-react';

const Rules = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  return (
    <div className="game-card mt-6">
      <div 
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center">
          <BookOpen size={20} className="text-emerald-600 mr-2" />
          <h2 className="text-lg font-semibold uyghur-text">ئويۇن قائىدىلىرى</h2>
        </div>
        <button className="text-gray-500">
          {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>
      </div>
      
      {isExpanded && (
        <div className="mt-4">
          <ul className="space-y-3 text-gray-700 uyghur-text">
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">1</div>
              <span>ھەر بىر سۆز ئالدىنقى سۆزنىڭ ئاخىرقى ھەرپى بىلەن باشلىنىشى كېرەك. مەسىلەن: ئالما → ئاتا → ئانا</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">2</div>
              <span>ئەگەر سۆز "ڭ" بىلەن ئاخىرلاشسا، كېيىنكى سۆز خالىغان ھەرپ بىلەن باشلانسا بولىدۇ. بۇ چۈنكى ئۇيغۇر تىلىدا "ڭ" بىلەن باشلىنىدىغان سۆز يوق.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">3</div>
              <span>بىر سۆزنى قايتا ئىشلەتسىڭىز بولمايدۇ. ھەر بىر سۆز پەقەت بىر قېتىم ئىشلىتىلىدۇ.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">4</div>
              <span>خاتا سۆز كىرگۈزسىڭىز ياكى ۋاقىت توشۇپ كەتسە، ئويۇن ئاخىرلىشىدۇ.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">5</div>
              <span>كىرگۈزگەن سۆزىڭىز چوقۇم لۇغەتتە بار بولۇشى كېرەك. بىزنىڭ لۇغىتىمىزدە 35,000 دىن ئارتۇق ئۇيغۇرچە سۆز بار.</span>
            </li>
          </ul>
          
          <div className="mt-4 p-3 bg-yellow-50 rounded-lg text-amber-700 uyghur-text">
            <p className="text-sm">ئەسكەرتىش: قىيىنلىق دەرىجىسى، ۋاقىت چەكلىمىسى قاتارلىق تەڭشەكلەرنى "تەڭشەكلەر" بەتتىن ئۆزگەرتەلەيسىز.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rules;